// Select all links with the classname
const links = Array.from(document.querySelectorAll('.scrollto'));

// Iterate over each link
links.forEach(link => {
	// Add click event listener
	link.addEventListener('click', (event) => {
		// Prevent the default link behavior
		event.preventDefault();

		// Extract the value of the data-scroll attribute
		const scrollTarget = link.getAttribute('data-scroll');

		// Scroll smoothly to the target element
		document.querySelector(scrollTarget).scrollIntoView({
			behavior: 'smooth'
		});
	});
});

const anchorLinks = Array.from(document.querySelectorAll('a[href^="#"]'));

anchorLinks.forEach(link => {
	link.addEventListener('click', (event) => {
		event.preventDefault();

		const targetId = link.getAttribute('href').slice(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			const offset = -100; // Adjust offset here
			const topPos = targetElement.getBoundingClientRect().top + window.pageYOffset + offset;

			window.scrollTo({
				top: topPos,
				behavior: 'smooth'
			});
		}
	});
});